import { useState } from 'react';
import { getDocumentNode } from '../../services/documents';
import { buildDocumentPath } from '../../utils/documentNavigation';

interface Props {
  nodeId: number;
  /** Nome già presente nella risposta dell'agent. Evita di mostrare un ID tecnico all'utente. */
  label?: string;
  onOpen?: (path: string) => void;
}

export function DocumentCitation({ nodeId, label, onOpen }: Props) {
  const [failed, setFailed] = useState(false);
  const [loading, setLoading] = useState(false);
  const displayLabel = label?.trim() || 'Fonte documentale';
  const open = async () => {
    setLoading(true); setFailed(false);
    try {
      const node = await getDocumentNode(nodeId);
      if (node.node_type !== 'FILE') throw new Error('not_file');
      const path = buildDocumentPath({ kind: 'file', spaceId: node.space_id, fileId: node.id });
      if (onOpen) onOpen(path); else window.location.assign(path);
    } catch { setFailed(true); }
    finally { setLoading(false); }
  };
  return (
    <span className="inline-flex flex-wrap items-center gap-1">
      <button
        type="button"
        className="font-medium text-[var(--hexa-purple)] underline disabled:cursor-wait disabled:opacity-70"
        disabled={loading}
        aria-label={`Apri fonte documento ${displayLabel}`}
        aria-busy={loading}
        onClick={open}
      >
        {displayLabel}
      </button>
      {loading && <span role="status" className="text-xs text-[var(--hexa-text-muted)]">Apertura...</span>}
      {failed && <span role="alert" className="text-xs text-red-700">Fonte non disponibile o non autorizzata</span>}
    </span>
  );
}
